import { createSelector } from 'reselect'
import type { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { EmptyArray } from 'lib/array/arrayUtils'

export function listFlashOfferStayDurations(packages: Array<{ duration: number }> | undefined): Array<number> {
  if (!packages?.length) return EmptyArray

  return [...new Set(packages.map(pkg => pkg.duration))].sort((left, right) => left - right)
}

export const getFlashCalendarLosDurations = createSelector(
  (state: OfferPageState) => state.offer?.packages,
  (packages): Array<number> => listFlashOfferStayDurations(packages),
)
